import './register_common_react';
import { reactOnCms } from 'common/js/react_on_cms';
import ExpiryBookingCheck from 'components/expiry_booking_check';
import AccountNavigation from 'tenants/sealink/account_navigation';

reactOnCms.register({
  ExpiryBookingCheck,
  AccountNavigation,
});
